/** @file Id → name lookup over one document table (falls back to the id for a dangling reference). */

/** A resolver for ids of `table`; queries answer names, so an id only shows when the document is broken. */
export function nameIn(table: Record<string, { name: string }>): (id: string) => string {
  return (id) => table[id]?.name ?? id;
}
